import { render, staticRenderFns } from "./CbsOrderby.vue?vue&type=template&id=e6027cfc&scoped=true"
import script from "./CbsOrderby.vue?vue&type=script&lang=js"
export * from "./CbsOrderby.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6027cfc",
  null
  
)

export default component.exports